export default __webpack_public_path__ + "static/media/emptycart.06a972d3.jpg";